/**
 * @fileoverview Constants for notes hooks including query keys, pagination defaults,
 * and error messages. Centralizes magic strings and values used across multiple hooks.
 */

/** Query keys for TanStack Query cache management */
export const NOTE_QUERY_KEYS = {
  /** Key for fetching all notes with tags and reference data */
  notesWithTags: ['notes', 'with-tags'] as const,
  /** Key for fetching a single note by ID */
  note: (noteId: string) => ['note', noteId] as const,
  /** Key for fetching similar notes by embedding distance */
  similarNotes: (noteId: string) => ['note', noteId, 'similar'] as const,
  /** Key for fetching backlinks (notes that link TO this note) */
  backlinks: (noteId: string) => ['note', noteId, 'backlinks'] as const,
  /** Key for fetching forward links (notes this note links TO) */
  forwardLinks: (noteId: string) => ['note', noteId, 'forward-links'] as const,
  /** Key for fetching unlinked mentions */
  unlinkedMentions: (noteId: string) => ['note', noteId, 'unlinked-mentions'] as const,
  /** Key for fetching tags with occurrence counts */
  tagsWithOccurrence: ['tags', 'with-occurrence'] as const,
} as const;

/** Default pagination parameters for fetching all items */
export const DEFAULT_PAGINATION = {
  page: '0',
  pageSize: '1000',
} as const;

/** Error messages for note operations */
export const NOTE_ERROR_MESSAGES = {
  noteNotFound: 'Note not found in local state',
  togglePin: 'Error toggling pin:',
  toggleBookmark: 'Error toggling bookmark:',
  toggleFlag: 'Error toggling flag:',
  deleteNote: 'Error deleting note:',
} as const;
